<div class="main-container">
  <div class="inside-main-container">
    <div>
      <app-counters-soft *ngIf="this.machineSessioned.maC_ModelloSx==1"></app-counters-soft>
      <app-counters-soft-touch *ngIf="this.machineSessioned.maC_ModelloSx==3"></app-counters-soft-touch>
      <app-counters-soft-touch *ngIf="this.machineSessioned.maC_ModelloSx==4"></app-counters-soft-touch>
    </div>
  </div>
</div>
